import React, { useEffect } from "react";
import { observer } from "mobx-react-lite";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { getCurrentUser } from "./cognito";

const antIcon = <LoadingOutlined style={{ fontSize: 16 }} spin />;

function Logout({ authStore }) {
  const navigate = useNavigate();

  useEffect(() => {
    getCurrentUser().then((user) => {
      if (user != null) {
        user.signOut();
      }
      navigate("/login");
    });
  }, [navigate]);

  return (
    <div className="Logout">
      <div className="Logout__wrapper">
        <div className="Logout__container">
          <Spin indicator={antIcon} /> Logging out ...
        </div>
      </div>
    </div>
  );
}

export default observer(Logout);
